import React from 'react';
import PropTypes from 'prop-types';

function ViewportGrid({
  numRows,
  numCols,
  layoutType,
  children,
  edgeToEdge = false,
  compactSpacing = false,
}) {
  return (
    <div
      data-cy="viewport-grid"
      className="relative flex h-full min-h-0 w-full flex-wrap"
      style={{
        position: 'relative',
        height: '100%',
        minHeight: 0,
        width: '100%',
        background: '#0B0F14',
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: compactSpacing ? 0 : '4px',
        ...(edgeToEdge && {
          display: 'grid',
          gridTemplateColumns: `repeat(${numCols}, minmax(0, 1fr))`,
          gridTemplateRows: `repeat(${numRows}, minmax(0, 1fr))`,
          height: '100%',
          minHeight: 0,
          gap: 0,
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          marginLeft: 0,
          padding: 0,
          border: 0,
          overflow: 'hidden',
        }),
      }}
    >
      {children}
    </div>
  );
}

ViewportGrid.propTypes = {
  /** Number of columns */
  numRows: PropTypes.number.isRequired,
  /** Number of rows */
  numCols: PropTypes.number.isRequired,
  layoutType: PropTypes.string,
  edgeToEdge: PropTypes.bool,
  compactSpacing: PropTypes.bool,
  /** Array of React Components to render within grid */
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default ViewportGrid;
